import { msg } from 'gt-react';
import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { z } from 'zod';
import { canManageStaffSectionsInRoute } from '@/hooks/authz/useCanManageStaffSections';
import { Route as pathlessAuthenticatedRoute } from '../../route';

const ControlPlaneLinkPage = lazyRouteComponent(
  () => import('./ControlPlaneLinkPage'),
  'ControlPlaneLinkPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/settings/control-plane-link',
  component: ControlPlaneLinkPage,
  // Handoff/enrollment tokens are carried in the URL hash fragment (not the
  // query string) to keep them out of server logs, so no search params are
  // expected on this route.
  validateSearch: z.object({}),
  beforeLoad: async ({ context }) => {
    // The Control Plane section is staff-only: Gently staff or an Update
    // OrganizationSettings holder (the handoff endpoint accepts both).
    if (!(await canManageStaffSectionsInRoute(context))) {
      throw redirect({
        to: '/settings/organization/$section',
        params: { section: 'products' },
      });
    }
  },
  loader: () => ({
    crumb: msg('Control Plane Link', { context: 'page breadcrumb' }),
  }),
});
